module.exports = __webpack_public_path__ + "media/images/common/shop_reserve/check-45c7ad2ca343271742309b23cbbcb629.svg";